import Dashboard from './Dashboard.js';
const AuthenticatedApp = (props) => {
  return (
    <Dashboard {...props}/>
  );
}
export default AuthenticatedApp;

